export const SECRET_KEY =
  "secretKeyjljlewrnvmlkmfkls21458031231%jkljejasd;32131hjjfdkflklnnvbfgaddksaksamdkasmdklamdakldmakldmnosfnofnasfajfafjafjafjkljkklmdka=";
